import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";

function Feedback() {
  const { t } = useTranslation();
  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId } = useParams();

  return (
    <Button
      onClick={() => handleNavigate(`/restaurants/${restaurantId}/get-receipt`)}
      label={t("transparentDrawer.button.getMyReceipt")}
      variant="contained"
      color="primary"
      maxWidth
      mobile={true}
    />
  );
}

export default Feedback;
